import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cb5727c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wr" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right-inner" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["AppModal"], {
    "is-open": $props.isOpen,
    classes: 'wrapper-padding-none bg-secondary',
    onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.close()))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["WeProposeApp"], {
          title: $setup.isMigratedToApp ? 'Open Our All in One App!' : 'Download Our All in One App!',
          "bold-desc": "Scan the code or use the links below to download!",
          "show-stay-in-browser": false
        }, null, 8, ["title"]),
        _hoisted_2
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}